export default {
  pageTitleEtc: getConfig("PAGE_TITLE") ?? "[DEV]ET Connect",
  pageTitleCompass: getConfig("PAGE_TITLE") ?? "[DEV]ET Compass",
  userManagementDataPersistKey: "etc-user-management-data",
  authDataPersistKey: "etc-auth-data",
  localeDataPersistKey: "etc-locale-data",
  quotationDataPersistKey: "etc-quotation-data",
  chargeweightDataPersistKey: "etc-chargeweight-data",
  etCoreAuthPersistKey: "et-core-auth",
  tokenPublicKey:
    getConfig("TOKEN_PUBLIC_KEY") ??
    //dev public key uncomment this if you want to push your changes -> else tests will fail
    "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApsZRUk03tI2aUlEepjqbLG01EfyPS+pi/Er7fn/uW850Y+MlzZOTjRApezPcUBUH+ogidwO3yfSmiiTV72sGKf3JURR99JtCNsSRHEscCqbmcRUWnpLfZwJrcIj64MUYZStGojpB4K5buQ0/itB1bsIl3lvBe5xxlXiY7mf1L2Els1Yra3+e6jT2JPbIrogR+PvJhV+Ic+UjvOcQPmTnGx15V2319eHaEVI0aCXplReuacY4fMxGFYdN5gaTPMNEDNeJjVAr28UOP9hZe5AcUWCvROfai4vPAWNaWxwKoj4CiR1ICY2f/6U83H0YEnL0DhXNpL4wPzcQDSebE5ZgowIDAQAB-----END PUBLIC KEY-----",
  //test public key -> for local development
  //"-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxPZyJvoxVA2vN75+EYHY+/r6xTCQx9SiUXdBs6cZOx2M9Lnmxx0e0k0kxgFwOx04HGqkiu66qoNbMaiMemF3qcs5tJjlnyHG3G98Vi6lFt0JKv9FPBUTqeOGwDqJSMcrNZQOe6mCPVPjAObgdTq7hAJrdXc879MzDEBfxjwLRVezApc72fey0NxCHfbonzbuhGGDtjWKlspQ98JXKSUveXclK5rO/O9m5l6j0Bje74taEHSxITgncWiGH2xHiXdvW2mBBv/e/WkbN/tmHSxLhXAUiBllIRg+8UV0kA1mep23FtTjL9KIF2QV23ygdTpEbE0S5Sjk9AroQvMi7IUbLwIDAQAB-----END PUBLIC KEY-----",
  apiEndpoints: {
    baseURL:
      buildUrl(
        getConfig("BACKEND_PROTOCOL"),
        getConfig("BACKEND_HOSTNAME"),
        getConfig("BACKEND_PORT"),
      ) ?? "http://localhost:8894/",
    itrURL:
      buildUrl(
        getConfig("ITR_BACKEND_PROTOCOL"),
        getConfig("ITR_BACKEND_HOSTNAME"),
        getConfig("ITR_BACKEND_PORT"),
      ) ?? "http://localhost:8893/",
    compassURL:
      buildUrl(
        getConfig("COMPASS_BACKEND_PROTOCOL"),
        getConfig("COMPASS_BACKEND_HOSTNAME"),
        getConfig("COMPASS_BACKEND_PORT"),
      ) ?? "http://localhost:8895/",
    etCoreURL:
      buildUrl(
        getConfig("ET_CORE_BACKEND_PROTOCOL"),
        getConfig("ET_CORE_BACKEND_HOSTNAME"),
        getConfig("ET_CORE_BACKEND_PORT"),
      ) ?? "http://localhost:8869/",
    auth: "/api-public",
    default: "/api",
    users: "/api/users",
    addresses: "/api/addresses",
    changelogs: "api/changelogs",
    loginInfos: "/api/logininfos",
    activeLoginInfos: "/api-public/active-logininfo-texts",
    permissions: "/api/permissions",
    permissionPresets: "/api/permission-presets",
    roles: "/api/roles",
    reportUrls: "/api/report-urls",
    accountManager: "/api/account-manager",
    feedback: "/api/feedback",
    unitcodes: "/api/unitcodes",
    routings: "/api/routings",
    transports: "/api/transports",
    quotation: "/api/quotation",
    copyItrUserSettings: "/itr/api/user-settings",
    departments: "/compass/api/customer-statistics/departments",
    chargeableWeightDepartments:
      "/compass/api/customer-statistics/chargeable-weight/departments",
    teuDepartments: "/compass/api/customer-statistics/teu/departments",
    widgets: "/compass/api/users/widgets",
    location: "/itr/api/location-data",
    shipmentTrackingDetails: "/itr/api-shipment-tracking/tracking-details",
    shipmentTrackingInquiry: "/itr/api-shipment-tracking/inquiry",
    shipmentTrackingMissingMilestones:
      "/itr/api-shipment-tracking/missing-milestones",
  },
  keycloak: {
    url: getConfig("KEYCLOAK_URL") ?? "https://auth-dev.egetrans.com/auth/",
    realm: getConfig("KEYCLOAK_REALM") ?? "etconnect",
    clientId: getConfig("KEYCLOAK_CLIENT_ID") ?? "compass",
  },
  sentryConfig: {
    dsn: getConfig("SENTRY_DSN") as string | undefined,
    env: (getConfig("SENTRY_ENV") as string | undefined) ?? "dev",
  },

  itrBackendProtocol: getConfig("ITR_BACKEND_PROTOCOL") ?? "http",
  itrBackendHost: getConfig("ITR_BACKEND_HOSTNAME") ?? "localhost",
  itrBackendPort: getConfig("ITR_BACKEND_PORT") ?? "8893",
  externalLinks: {
    shipmentTracking: "https://et-connect.egetrans.com/shipment-tracking",
    personio: "https://egetrans.app.personio.com/",
    lighthouse: "https://etlighthouse.egetrans.com/",
    etAcademy: "https://et-academy.de/",
  },
  isCompass: (getConfig("IS_COMPASS") as boolean) ?? true,
  registrationWaitTimeInSeconds:
    getConfig("REGISTRATION_WAIT_TIME_IN_SECONDS") ?? 1,
  loginCooldownInSeconds: getConfig("LOGIN_COOLDOWN_IN_SECONDS") ?? 2,
  pricingEmail: "pricing@egetrans.com",
  matomoConfig: {
    enabled: Boolean(getConfig("MATOMO_HOST") ?? false),
    host:
      getConfig("MATOMO_HOST") ?? "https://etubuntu64etc02.egetrans.com:14355",
    siteID: getConfig("MATOMO_SITE_ID") ?? 2,
    trackerFileName: getConfig("MATOMO_TRACKER_FILE_NAME") ?? "matomo",
    enableHeartBeatTimer: getConfig("MATOMO_ENABLE_HEART_BEAT_TIMER") ?? true,
    heartBeatTimerInterval: getConfig("MATOMO_HEART_BEAT_TIMER_INTERVAL") ?? 15,
    debug: getConfig("MATOMO_DEBUG") ?? true,
  },
  storageKey:
    getConfig("SECRET_KEY") ??
    "oxrRuJDSpTndoKX5XZsKHP3r3B8BeMEdSBKMYQsUX6rqCDs6MZ5D7WjXUyuhpgZ5osjoUPXsZNAZJFonvU33jJCPgkAFNTSZKvePA2LjiBZpt3kxCMbvYHCR3Xga9YAi",
};

function buildUrl(
  protocol: string,
  hostname: string,
  port: string,
): string | undefined {
  return protocol && hostname && port
    ? `${protocol}://${hostname}:${port}/`
    : undefined;
}

function getConfig(key: string) {
  // @ts-ignore: window.config will be set dynamically in the index.html by replacing a placeholder
  return window?.config?.[key];
}
